module.exports = __webpack_public_path__ + "img/unibh.b2859e05.svg";